function setCookie(cName: string, cValue: string, expDays: number) {
    let date = new Date();
    date.setTime(date.getTime() + (expDays * 24 * 60 * 60 * 1000));
    const expires = "expires=" + date.toUTCString();
    document.cookie = cName + "=" + cValue + "; " + expires + "; path=/";
}

function resetCookies() {
    const form = document.getElementById("cookieForm") as HTMLFormElement;
    const FD = new FormData(form);
    const choice = FD.get("cookieChoice");

    if ("accept" === choice) {
        setCookie("mhclg_analytics", "accept", 365)
    } else {
        setCookie("mhclg_analytics", "reject", 365)
        document.cookie = "_gae=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/";
        document.cookie = "_gat_gtag_UA_107121542_2=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/";
        document.cookie = "_gid=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/";
        document.cookie = "_ga=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/";
    }
}

const cookieButton = document.getElementById("cookieButton");

cookieButton!.addEventListener("click", function (event) {
    event.preventDefault();
    resetCookies()
    window.location.href = "successfully-updated-cookies"
});
